import { defaultPageSize } from "helpers/utils";
import { useState } from "react";

const useChips = (initialChips = []) => {
	const [chips, setChips] = useState(initialChips);
	const [isDropDownChanging, setDropDownChange] = useState(false);
	const [isRemovingChip, setIsRemovingChip] = useState(false);
	const [autocompleteData, setAutocompleteData] = useState([]);
	const [dataForFetchingDefect, setDataForFetchingDefect] = useState({
		pageNumber: 1,
		pageSize: defaultPageSize(),
		search: "",
		sortField: "",
		sort: "",
	});

	// Add a new chip to the array, avoiding duplicates
	const addChip = (newChip) => {
		setChips((prev) => {
			const isDuplicate = prev?.some(
				(existingItem) =>
					existingItem.id === newChip.id &&
					existingItem.chipType === newChip.chipType &&
					existingItem.value === newChip.value
			);
			return !isDuplicate ? [...prev, newChip] : prev;
		});
	};

	// Remove a chip by its index or properties
	const removeChip = (chipToRemove) => {
		setIsRemovingChip(true);
		setDropDownChange(false);
		setChips((prev) => {
			return prev.filter(
				(item, index) =>
					(item.id !== chipToRemove.id && index !== chipToRemove.index) ||
					(item.value.length !== chipToRemove.value.length &&
						index !== chipToRemove.index) ||
					(item.value !== chipToRemove.value && index !== chipToRemove.index)
			);
		});
		setIsRemovingChip(false);
	};

	//handle autocomplete contents
	const handleAutoCompleteContent = async (item) => {
		setDropDownChange(false);
		setChips((prev) => {
			const isDuplicate = prev?.some(
				(existingItem) =>
					existingItem.id === item.id &&
					existingItem.chipType === item.chipType &&
					existingItem.value === item.value
			);
			if (!isDuplicate) {
				return [...prev, item];
			}

			return prev;
		});
		setAutocompleteData([]);
		setDataForFetchingDefect({
			pageNumber: 1,
			pageSize: defaultPageSize(),
			search: "",
			sortField: "",
			sort: "",
		});
	};
	return {
		addChip,
		chips,
		isDropDownChanging,
		isRemovingChip,
		handleRemoveChip: removeChip,
		setChips,
		setDropDownChange,
		setDataForFetchingDefect,
		dataForFetchingDefect,
		autocompleteData,
		setAutocompleteData,
		handleAutoCompleteContent,
	};
};

export default useChips;
